import React from 'react';
import { motion } from 'framer-motion';
import styled from '@emotion/styled';

const StyledContainer = styled.div`
  min-height: 100vh;
  position: relative;
  z-index: 1;
`;

const Container = motion(StyledContainer);

const Layout = ({ children }) => {
  return (
    <Container
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.5 }}
    >
      {children}
    </Container>
  );
};

export default Layout;
